import { useAllOrderStore } from "modules/order_management/store";
import React, { useEffect, useMemo } from "react";
import { ADMIN_REP_ACCESS } from "./engagement_cf";
import { isEmpty } from "lodash";
import { currentUser } from "modules/utilities/utility";
import { Badge, Button, Select, Space } from "antd";

function SelectAssignee({
  assign,
  setAssign,
  handleAssign,
  updateLoading,
  slotBooking,
  hourEngData
}) {
  const {
    medicalData,
    consultData,
    operationData,
    fetchMedicalRep,
    fetchConsultRep,
    fetchOperations,
  } = useAllOrderStore();

  useEffect(() => {
    isEmpty(medicalData) && fetchMedicalRep();
    isEmpty(consultData) && fetchConsultRep();
    isEmpty(operationData) && fetchOperations();
  }, []);

  return (
    <div>
      {ADMIN_REP_ACCESS.includes(currentUser) ? (
        <div>
          <div className="d-flex flex-row">
            <Select
              allowClear
              onChange={(selectedRowKeys) => setAssign(selectedRowKeys)}
              optionFilterProp="label"
              placeholder="Select a person"
              showSearch
              style={{ width: 180, marginLeft: 10 }}
              value={assign}
            >
             {!isEmpty(hourEngData)&& slotBooking &&
                hourEngData?.map((rep) => (
                  <Option
                    label={rep?.first_name}
                    value={rep?.user_id}
                    key={rep?.user_id}
                  >
                    <Space align="center">
                      <div>{rep?.first_name}</div>
                      <Badge
                        count={rep?.count}
                        style={{
                          backgroundColor: "#f1f1f1",
                          color: "#313131",
                        }}
                      />
                    </Space>
                  </Option>
                ))}
              {!isEmpty(medicalData) && !slotBooking &&
                medicalData?.userRole?.map((rep) => (
                  <Option
                    label={rep.user.first_name}
                    value={rep.user.id}
                    key={rep.user.id}
                  >
                    <Space align="center">
                      <div>{rep.user.first_name}</div>
                      <Badge
                        count="Medical Rep"
                        style={{
                          backgroundColor: "#f1f1f1",
                          color: "#313131",
                        }}
                      />
                    </Space>
                  </Option>
                ))}
              
              {!isEmpty(consultData) && !slotBooking &&
                consultData?.userRole?.map((rep) => (
                  <Option
                    label={rep.user.first_name}
                    value={rep.user.id}
                    key={rep.user.id}
                  >
                    <Space align="center">
                      <div>{rep.user.first_name}</div>
                      <Badge
                        count="Consult Rep"
                        style={{
                          backgroundColor: "#f1f1f1",
                          color: "#313131",
                        }}
                      />
                    </Space>
                  </Option>
                ))}

              {!isEmpty(operationData) && !slotBooking &&
                operationData?.userRole?.map((rep) => (
                  <Option
                    label={rep.user.first_name}
                    value={rep.user.id}
                    key={rep.user.id}
                  >
                    <Space align="center">
                      <div>{rep.user.first_name}</div>
                      <Badge
                        count="Operations Rep"
                        style={{
                          backgroundColor: "#f1f1f1",
                          color: "#313131",
                        }}
                      />
                    </Space>
                  </Option>
                ))}
            </Select>
            <Button className="ms-n2" type="primary" loading={updateLoading}  onClick={handleAssign}>
              Assign
            </Button>
          </div>
        </div>
      ) : null}
    </div>
  );
}

export default SelectAssignee;
